import { render, staticRenderFns } from "./Articll_list.vue?vue&type=template&id=0bfb21e7&"
import script from "./Articll_list.vue?vue&type=script&lang=js&"
export * from "./Articll_list.vue?vue&type=script&lang=js&"
import style0 from "./Articll_list.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports